import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/pages/AboutStory.scss';

function AboutStory() {
  const navigate = useNavigate();

  const milestones = [
    {
      year: '2018',
      title: 'Foundation of Pravara Infotech',
      description: 'Pravara Infotech was established in 2018 with a vision to bridge the gap between technology, education, and business. Starting with a small team of passionate technology enthusiasts, the company focused on delivering software solutions, websites, and digital services that addressed real-world challenges. From the beginning, our mission has been to empower businesses, students, and institutions through innovation, practical learning, and technology-driven growth.'
    },
    {
      year: '2020',
      title: 'Growth & Digital Solutions Expansion',
      description: 'As digital transformation accelerated across industries, Pravara Infotech expanded its service portfolio to include custom software development, website design and development, business automation solutions, and enterprise applications. During this phase, the company successfully completed numerous projects for startups, educational institutions, local businesses, and organizations, helping them establish a stronger digital presence and improve operational efficiency.'
    },
    {
      year: '2022',
      title: 'Training, Internship & Academic Collaborations',
      description: 'Recognizing the growing need for industry-ready talent, Pravara Infotech launched structured internship programs, industrial training initiatives, and project development services for Engineering, MBA, MCA, BCA, Diploma, and other professional courses. The company strengthened its relationships with colleges, universities, and academic institutions by providing practical learning opportunities, technical workshops, project guidance, and skill development programs aimed at enhancing student employability.'
    },
    {
      year: '2024',
      title: '1000+ Projects Delivered Milestone',
      description: "Pravara Infotech achieved a significant milestone by successfully delivering more than 1000 projects across various domains, including software development, web applications, academic projects, research-based solutions, internships, and training programs. This achievement reflected the company's commitment to quality, innovation, and customer satisfaction. During this period, the company expanded its client base and established itself as a trusted technology partner for students, educational institutions, startups, and businesses."
    },
    {
      year: '2026',
      title: 'CSR Collaborations, Industry Partnerships & 2000+ Projects Annually',
      description: "In 2026, Pravara Infotech reached a new phase of growth through strategic collaborations and largescale impact initiatives. The company partnered with Medhavi Foundation (Kolkata) under various CSR-driven programs focused on skill development, digital literacy, employability enhancement, and technology education. These collaborations enabled Pravara Infotech to contribute towards empowering students, rural youth, and aspiring professionals through practical training, project-based learning, internships, and industry-oriented skill development initiatives. With a strong ecosystem of academic and industry partnerships, Pravara Infotech now delivers more than 2000+ projects annually across software development, website solutions, training programs, research guidance, academic projects, internships, and business technology solutions. The company continues to leverage emerging technologies, automation, and innovation-driven practices to create meaningful impact for students, institutions, startups, and enterprises. Today, Pravara Infotech stands as a trusted technology partner dedicated to fostering innovation, enhancing skills, and driving digital transformation across education and business sectors."
    }
  ];

  return (
    <div className="about-story-page">
      {/* Hero Section */}
      <section className="story-hero" style={{ backgroundImage: "linear-gradient(135deg, rgba(10, 37, 64, 0.85), rgba(0, 82, 106, 0.85)), url('/images/about-bg.jpg')" }}>
        <h1>Our Story</h1>
        <p>The journey of building a leading technology company</p>
      </section>

      {/* Main Content */}
      <div className="story-page-container">
        {/* Back Button */}
        <div className="back-btn-wrapper">
          <button className="btn-back" onClick={() => navigate('/about')}>
            <span>&larr;</span> Back to About
          </button>
        </div>

        {/* Story Intro */}
        <section className="story-intro">
          <div className="story-intro-content">
            <span className="subtitle">HOW IT STARTED</span>
            <h2>A Vision to Empower Businesses and Students Through Technology</h2>
            <p>
              Pravara Infotech was founded in 2018 with a vision to make technology accessible, practical, and impactful for businesses, students, and educational institutions. What started as a small initiative focused on software development and digital solutions has grown into a trusted technology partner delivering websites, software solutions, internships, training programs, and academic project guidance.
            </p>
            <p>
              Driven by innovation, quality, and a commitment to continuous learning, Pravara Infotech has successfully supported thousands of students, startups, businesses, and organizations in achieving their goals through technology.
            </p>
          </div>
          <div className="story-intro-image">
            <img src="/images/about-team.jpg" alt="Our Team Collaborating" />
          </div>
        </section>

        {/* Milestone Timeline */}
        <section className="story-timeline-section">
          <h2>Key Milestones</h2>
          <p className="timeline-desc">Tracing Our Journey from a Startup to a Trusted Technology Partner</p>
          
          <div className="story-timeline">
            {milestones.map((item, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-badge">{item.year}</div>
                <div className="timeline-panel">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Looking Ahead Section */}
        <section className="looking-ahead-section">
          <h2>Looking Ahead</h2>
          <p>
            Pravara Infotech remains committed to its vision of empowering individuals and organizations through technology. 
            By continuously adopting emerging technologies, strengthening industry-academia collaborations, and delivering 
            innovative digital solutions, the company aims to create sustainable growth opportunities and contribute to 
            the development of a digitally empowered future.
          </p>
        </section>

        {/* Leadership Message */}
        <section className="leadership-message">
          <div className="quote-icon">&ldquo;</div>
          <div className="message-content">
            <blockquote>
              "At Pravara InfoTech, we believe that software is more than just code — it is a tool to solve human problems, 
              streamline complex processes, and open up new avenues of growth. Our commitment is to remain at the cutting 
              edge of innovation while staying deeply connected to our clients' core objectives."
            </blockquote>
            <cite>
              <strong>Nishant Kale</strong>
              <span>CEO & Founder, Pravara InfoTech</span>
            </cite>
          </div>
        </section>
      </div>
    </div>
  );
}

export default AboutStory;
